import { useTranslation } from "@nova/use-translation"
import { useEffect, useState } from "react"
import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import { ButtonInlineIcon } from "@nova/component-btn"

export const TableHeader = ({
    primaryKey,
    headerKey,
    title,
    className,
    isDefault,
    setSearchDirection,
}: {
    primaryKey: string
    headerKey: string
    title: string
    className?: string
    isDefault?: boolean
    setSearchDirection: (sortDirection: "asc" | "desc") => void
}) => {
    const { t } = useTranslation()
    const [isHovering, setIsHovering] = useState(false)
    const [direction, setDirection] = useState<"asc" | "desc" | undefined>(
        isDefault ? "asc" : undefined
    )

    useEffect(() => {
        if (headerKey !== primaryKey) setDirection(undefined)
    }, [primaryKey, headerKey])

    const headerClasses = "pl-5 py-[0.313rem]"
    const icon = !direction
        ? Icons.NoFilterArrow
        : direction === "asc"
          ? Icons.AscendingArrow
          : Icons.DescendingArrow
    return (
        <th
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
            className={classNames(headerClasses, "sticky top-0 z-10 bg-gray-700", className)}
        >
            <div className="flex items-center justify-between">
                <small className="xs w-max text-gray-100 font-normal">{t(title)}</small>
                <ButtonInlineIcon
                    icon={icon}
                    className="!mr-3 focus:!bg-transparent"
                    iconClassName={classNames("!pb-0 !pr-0 scale-125", {
                        "opacity-0": !isHovering && !direction,
                    })}
                    onClick={() => {
                        const newDirection = direction === "asc" ? "desc" : "asc"
                        setSearchDirection(newDirection)
                        setDirection(newDirection)
                    }}
                />
            </div>
        </th>
    )
}
